import { useEffect, useState } from 'react';

import { Button } from '@material-ui/core';

import { FACEBOOK_APP_ID } from '../../config';
import { FB_VERSION, startFacebookLogin } from './facebookAccount';

/**
 * Facebook Login button in the shape YoutubeLogin uses, so the two sit
 * together on the newer login screens. The older class-based FacebookLogin
 * renders its own Grid and blue box, which does not match those pages.
 *
 * Instagram creator accounts sign in through Facebook — Meta gives them no
 * standalone OAuth — so this is the entry point for creators as well as the
 * Facebook one.
 */

function loadFacebookSdk() {
  return new Promise((resolve) => {
    if (window.FB) {
      resolve(window.FB);
      return;
    }
    window.fbAsyncInit = function fbAsyncInit() {
      window.FB.init({
        appId: FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: FB_VERSION,
      });
      resolve(window.FB);
    };
    if (document.getElementById('facebook-jssdk')) return;
    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  });
}

function FacebookLoginButton({ label, onSuccess, onFailure, userType, is_linked }) {
  const [ready, setReady] = useState(Boolean(window.FB));

  useEffect(() => {
    let active = true;
    loadFacebookSdk().then(() => {
      if (active) setReady(true);
    });
    return () => {
      active = false;
    };
  }, []);

  const login = () => {
    if (!window.FB) {
      if (onFailure) onFailure(new Error('Facebook sign-in is still loading.'));
      return;
    }
    startFacebookLogin(window.FB, {
      userType,
      onSuccess,
      onError: (error) => {
        // 'cancelled' just means they closed the dialog, so say nothing.
        if (error.message === 'cancelled') return;
        if (onFailure) onFailure(error);
      },
    });
  };

  return (
    <Button
      variant="contained"
      onClick={login}
      disabled={is_linked || !ready}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        textTransform: 'none',
        color: '#fff',
        backgroundColor: '#1877F2',
        padding: '13px 18px',
        borderRadius: '12px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontSize: '15px',
        fontWeight: 700,
        width: '100%',
        boxShadow: 'none',
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#fff"
          d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
        />
      </svg>
      {label || 'Continue with Facebook'}
    </Button>
  );
}

export default FacebookLoginButton;
